import { Fonts } from '../../theme';
import { textStyles } from '../../theme/fonts-ppv';

export default {
  inputDefault: {
    width: 300,
    height: 88,
    borderRadius: 4,
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
  },
};
